import { InlineFormattedNumber, Text, type Security } from '@talos/kyoko';
import { memo, type PropsWithChildren } from 'react';
import { useTheme } from 'styled-components';
import { TradeIndicator } from '../TradeDirection';

interface TradeDirectionParams {
  security: Security;
  direction: number;
  lastPrice: string;
}

export const TradeDirection = memo(
  ({ security, direction, lastPrice, children }: PropsWithChildren<TradeDirectionParams>) => {
    const theme = useTheme();
    const color = direction < 0 ? theme.colorTextNegative : theme.colorTextPositive;

    return (
      <>
        {lastPrice && lastPrice !== '0' && (
          <>
            <Text
              color={color}
              size={theme.fontSizeDefault}
              weight="fontWeightMedium"
              data-testid="trade-direction-price"
            >
              <InlineFormattedNumber
                highlightColor={color}
                number={lastPrice}
                round={true}
                specification={security.PriceDisplaySpec}
                increment={security.DefaultPriceIncrement}
              />
            </Text>
          </>
        )}
        <TradeIndicator scale={direction < 0 ? -0.75 : 0.75} fill={color} />
        {children}
      </>
    );
  }
);
